import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'
import {IStyleParam, StyleParamType, createStylesParams, wixColorParam} from '@wix/tpa-settings'
import {
  ALIGNMENT,
  BUTTONS_STYLE,
  CALENDAR_LAYOUT,
  DEFAULT_WEEK_START,
  EVENT_BADGE_LAYOUT,
  IMAGE_ALIGNMENT,
  IMAGE_HOVER_EFFECT,
  IMAGE_RATIO,
  IMAGE_SCALING,
  ITEM_HEIGHT_TYPE,
  LIST_ALIGNMENT,
  LIST_IMAGE_LAYOUT,
  LIST_IMAGE_SIZE,
  LIST_LAYOUT,
  LIST_LAYOUT_TYPE,
  LIST_LOCATION_AND_DATE_FORMAT,
  MOBILE_LIST_LAYOUT,
  MOBILE_LIST_LAYOUT_TYPE,
  MOBILE_WIDGET_LAYOUT,
  ON_IMAGE_CARD_HEIGHT_BEHAVIOR,
  VERTICAL_ALIGNMENT,
  WIDGET_LAYOUT,
  WIDGET_TYPE,
} from '@wix/wix-events-commons-statics'
import {Override} from '../../commons/types/utils'
import {getDefaultFont} from '../../settings-commons/utils/style'
import {ISettingsNumbers, WidgetComponentTextSettings} from './settingsParams'
import {
  DeprecatedBooleans,
  DeprecatedColors,
  DeprecatedFonts,
  DeprecatedNumbers,
  createDeprecatedStyles,
} from './stylesParams/deprecated-styles'
import {
  getWidgetDateVisibilityDefault,
  getWidgetLocationDateFormatDefault,
  getWidgetLocationVisibilityDefault,
} from './Widget/style-helpers/new-styles'
import {WidgetText} from './Widget/style-helpers/studio/constants'
import {getV2ParamsMap} from './Widget/style-helpers/studio/mapper'
import {
  getSocialShareDefault,
  getWidgetButtonDefaultFont,
  getWidgetFontColorDefault,
  getWidgetFontDefault,
} from './Widget/style-helpers/studio/utils'

type IStylesNumbers = {
  borderWidth: StyleParamType.Number
  todayButtonBorderWidth: StyleParamType.Number
  todayButtonBorderRadius: StyleParamType.Number
  listRoundedButtonBorderRadius: StyleParamType.Number
  calendarCellBorderWidth: StyleParamType.Number
  calendarBorderWidth: StyleParamType.Number
  buttonsBorderWidth: StyleParamType.Number
  todayRoundedButtonBorderRadius: StyleParamType.Number
  listButtonBorderRadius: StyleParamType.Number
  listButtonBorderWidth: StyleParamType.Number
  calendarDetailsTitleTextSize: StyleParamType.Number
  calendarDetailsDateLocationTextSize: StyleParamType.Number
  calendarDetailsDescriptionTextSize: StyleParamType.Number
  widgetType: StyleParamType.Number
  listLayout: StyleParamType.Number
  listLayoutType: StyleParamType.Number
  mobileListLayout: StyleParamType.Number
  mobileWidgetLayout: StyleParamType.Number
  mobileListLayoutType: StyleParamType.Number
  widgetLayout: StyleParamType.Number
  alignment: StyleParamType.Number
  contentAlignment: StyleParamType.Number
  listAlignment: StyleParamType.Number
  imagePosition: StyleParamType.Number
  verticalImagePosition: StyleParamType.Number
  imageGridPosition: StyleParamType.Number
  imageScaling: StyleParamType.Number
  multiImageScaling: StyleParamType.Number
  multiImageRatio: StyleParamType.Number
  listImageSize: StyleParamType.Number
  /**
   * @deprecated
   */
  imageRatio: StyleParamType.Number
  listImageLayout: StyleParamType.Number
  locationAndDateFormat: StyleParamType.Number
  cardsPerRow: StyleParamType.Number
  buttonsStyle: StyleParamType.Number
  buttonsBorderRadius: StyleParamType.Number
  roundedButtonsBorderRadius: StyleParamType.Number
  buttonHeight: StyleParamType.Number
  oneButtonWidth: StyleParamType.Number
  verticalDividerWidth: StyleParamType.Number
  verticalDividerHeight: StyleParamType.Number
  horizontalDividerWidth: StyleParamType.Number
  horizontalDividerHeight: StyleParamType.Number
  compactHorizontalDividerWidth: StyleParamType.Number
  compactHorizontalDividerHeight: StyleParamType.Number
  countdownMarginBottom: StyleParamType.Number
  titleMarginBottom: StyleParamType.Number
  descriptionMarginBottom: StyleParamType.Number
  dateMarginBottom: StyleParamType.Number
  locationMarginBottom: StyleParamType.Number
  dateAndLocationMarginBottom: StyleParamType.Number
  rsvpMarginBottom: StyleParamType.Number
  imageWidth: StyleParamType.Number
  imageOpacity: StyleParamType.Number
  listButtonStyle: StyleParamType.Number
  gapBetweenCards: StyleParamType.Number
  /**
   * @deprecated
   */
  listImageOpacity: StyleParamType.Number
  multiImageOpacity: StyleParamType.Number
  multiImageTopMargin: StyleParamType.Number
  multiImageBottomMargin: StyleParamType.Number
  multiImageLeftMargin: StyleParamType.Number
  multiImageRightMargin: StyleParamType.Number
  multiImagePosition: StyleParamType.Number
  multiImageBorderWidth: StyleParamType.Number
  multiImageTopLeftBorderRadius: StyleParamType.Number
  multiImageTopRightBorderRadius: StyleParamType.Number
  multiImageBottomLeftBorderRadius: StyleParamType.Number
  multiImageBottomRightBorderRadius: StyleParamType.Number
  listImageWidth: StyleParamType.Number
  calendarWeekStartDay: StyleParamType.Number
  calendarListTextSize: StyleParamType.Number
  calendarListDividerWidth: StyleParamType.Number
  todayButtonStyle: StyleParamType.Number
  recurringFilter: StyleParamType.Number
  listLocationAndDateFormatV2: StyleParamType.Number
  listCountdownTopLeftBorderRadius: StyleParamType.Number
  listCountdownTopRightBorderRadius: StyleParamType.Number
  listCountdownBottomLeftBorderRadius: StyleParamType.Number
  listCountdownBottomRightBorderRadius: StyleParamType.Number
  listTopMargin: StyleParamType.Number
  listBottomMargin: StyleParamType.Number
  listLeftMargin: StyleParamType.Number
  listRightMargin: StyleParamType.Number
  listItemTopPadding: StyleParamType.Number
  listItemBottomPadding: StyleParamType.Number
  listItemLeftPadding: StyleParamType.Number
  listItemRightPadding: StyleParamType.Number
  itemFixedHeight: StyleParamType.Number
  itemHeightType: StyleParamType.Number
  topLeftBorderRadius: StyleParamType.Number
  topRightBorderRadius: StyleParamType.Number
  bottomLeftBorderRadius: StyleParamType.Number
  bottomRightBorderRadius: StyleParamType.Number
  eventBoxShadowDistance: StyleParamType.Number
  eventBoxShadowBlur: StyleParamType.Number
  eventBoxShadowAngle: StyleParamType.Number
  listImageHoverEffect: StyleParamType.Number
  listTextVerticalAlignment: StyleParamType.Number
  listItemBorderAndDividerWidth: StyleParamType.Number
  widgetBorderWidth: StyleParamType.Number
  onImageCardHeightBehavior: StyleParamType.Number
  eventBadgeLayout: StyleParamType.Number
  eventBadgeVerticalAlignment: StyleParamType.Number
  eventBadgeHorizontalAlignment: StyleParamType.Number
  firstPriorityEventBadgeBorderWidth: StyleParamType.Number
  secondPriorityEventBadgeBorderWidth: StyleParamType.Number
  thirdPriorityEventBadgeBorderWidth: StyleParamType.Number
  firstPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  firstPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  secondPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeTopLeftBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeTopRightBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeBottomLeftBorderRadius: StyleParamType.Number
  thirdPriorityEventBadgeBottomRightBorderRadius: StyleParamType.Number
  calendarTopMargin: StyleParamType.Number
  calendarBottomMargin: StyleParamType.Number
  calendarLeftMargin: StyleParamType.Number
  calendarRightMargin: StyleParamType.Number
  calendarHeight: StyleParamType.Number
  calendarGridTopPadding: StyleParamType.Number
  calendarGridBottomPadding: StyleParamType.Number
  calendarGridLeftPadding: StyleParamType.Number
  calendarGridRightPadding: StyleParamType.Number
  calendarGridHorizontalGap: StyleParamType.Number
  calendarGridVerticalGap: StyleParamType.Number
  calendarGridBorderWidth: StyleParamType.Number
  calendarGridTopLeftBorderRadius: StyleParamType.Number
  calendarGridTopRightBorderRadius: StyleParamType.Number
  calendarGridBottomLeftBorderRadius: StyleParamType.Number
  calendarGridBottomRightBorderRadius: StyleParamType.Number
  calendarGridBoxShadowDistance: StyleParamType.Number
  calendarGridBoxShadowAngle: StyleParamType.Number
  calendarGridBoxShadowBlur: StyleParamType.Number
  calendarCellTopLeftBorderRadius: StyleParamType.Number
  calendarCellTopRightBorderRadius: StyleParamType.Number
  calendarCellBottomLeftBorderRadius: StyleParamType.Number
  calendarCellBottomRightBorderRadius: StyleParamType.Number
  calendarCellBoxShadowDistance: StyleParamType.Number
  calendarCellBoxShadowAngle: StyleParamType.Number
  calendarCellBoxShadowBlur: StyleParamType.Number
  calendarCellTopPadding: StyleParamType.Number
  calendarCellBottomPadding: StyleParamType.Number
  calendarCellLeftPadding: StyleParamType.Number
  calendarCellRightPadding: StyleParamType.Number
  calendarCellHorizontalAlignment: StyleParamType.Number
  calendarHeaderBorderWidth: StyleParamType.Number
  calendarHeaderTopLeftBorderRadius: StyleParamType.Number
  calendarHeaderTopRightBorderRadius: StyleParamType.Number
  calendarHeaderBottomLeftBorderRadius: StyleParamType.Number
  calendarHeaderBottomRightBorderRadius: StyleParamType.Number
  calendarHeaderTopPadding: StyleParamType.Number
  calendarHeaderRightPadding: StyleParamType.Number
  calendarHeaderBottomPadding: StyleParamType.Number
  calendarHeaderLeftPadding: StyleParamType.Number
  calendarHeaderBoxShadowDistance: StyleParamType.Number
  calendarHeaderBoxShadowAngle: StyleParamType.Number
  calendarHeaderBoxShadowBlur: StyleParamType.Number
  eventsPerCalendarCell: StyleParamType.Number
  calendarWeekdaysHorizontalAlignment: StyleParamType.Number
  calendarWeekdaysBottomMargin: StyleParamType.Number
  calendarLayoutType: StyleParamType.Number
  calendarPopupHorizontalAlignment: StyleParamType.Number
  calendarPopupTopPadding: StyleParamType.Number
  calendarPopupBottomPadding: StyleParamType.Number
  calendarPopupLeftPadding: StyleParamType.Number
  calendarPopupRightPadding: StyleParamType.Number
  calendarEventPopupBorderWidth: StyleParamType.Number
  calendarEventPopupTopLeftBorderRadius: StyleParamType.Number
  calendarEventPopupTopRightBorderRadius: StyleParamType.Number
  calendarEventPopupBottomLeftBorderRadius: StyleParamType.Number
  calendarEventPopupBottomRightBorderRadius: StyleParamType.Number
  calendarEventPopupBoxShadowDistance: StyleParamType.Number
  calendarEventPopupBoxShadowAngle: StyleParamType.Number
  calendarEventPopupBoxShadowBlur: StyleParamType.Number
  calendarRsvpButtonStyle: StyleParamType.Number
  calendarRsvpButtonBorderWidth: StyleParamType.Number
  calendarRoundedRsvpButtonBorderRadius: StyleParamType.Number
  calendarRsvpButtonBorderRadius: StyleParamType.Number
} & DeprecatedNumbers

type IStylesBooleans = {
  showImage: StyleParamType.Boolean
  showCountdown: StyleParamType.Boolean
  showOfferRibbon: StyleParamType.Boolean
  showRecurringRibbon: StyleParamType.Boolean
  showTitle: StyleParamType.Boolean
  showDescription: StyleParamType.Boolean
  showDate: StyleParamType.Boolean
  showLocation: StyleParamType.Boolean
  showShareOptions: StyleParamType.Boolean
  showFullDividers: StyleParamType.Boolean
  showHorizontalDividers: StyleParamType.Boolean
  showCompactDividers: StyleParamType.Boolean
  showLabels: StyleParamType.Boolean
  showRSVPTitle: StyleParamType.Boolean
  showMembers: StyleParamType.Boolean
  listShowMainTitle: StyleParamType.Boolean
  listShowDescription: StyleParamType.Boolean
  listShowSocialShare: StyleParamType.Boolean
  listShowImage: StyleParamType.Boolean
  listShowAdditionalInfo: StyleParamType.Boolean
  listShowMembers: StyleParamType.Boolean
  listShowCountdown: StyleParamType.Boolean
  showSoldOutRibbon: StyleParamType.Boolean
  /**
   * @deprecated showRibbon is split into multiple other flags
   */
  showRibbon: StyleParamType.Boolean
  showRsvpClosedRibbon: StyleParamType.Boolean
  showJoinWaitlistRibbon: StyleParamType.Boolean
  listExtraInfoShowDate: StyleParamType.Boolean
  listExtraInfoShowLocation: StyleParamType.Boolean
  listShowDateV2: StyleParamType.Boolean
  listShowLocationV2: StyleParamType.Boolean
  eventBoxShadowVisible: StyleParamType.Boolean
  eventBadgeStretched: StyleParamType.Boolean
  showFirstPriorityEventBadge: StyleParamType.Boolean
  showSecondPriorityEventBadge: StyleParamType.Boolean
  showThirdPriorityEventBadge: StyleParamType.Boolean
  calendarGridBoxShadowVisible: StyleParamType.Boolean
  calendarCellBoxShadowVisible: StyleParamType.Boolean
  calendarHeaderBoxShadowVisible: StyleParamType.Boolean
  calendarEventPopupBoxShadowVisible: StyleParamType.Boolean
} & DeprecatedBooleans

type IStylesFonts = {
  calendarMonthFont: StyleParamType.Font
  calendarWeekdaysFont: StyleParamType.Font
  calendarDayNumberFont: StyleParamType.Font
  calendarCellEventNameFont: StyleParamType.Font
  calendarCellEventNameFontNew: StyleParamType.Font
  calendarCellEventTimeFont: StyleParamType.Font
  calendarCellMoreEventsFont: StyleParamType.Font
  calendarEventPopupEventNameFont: StyleParamType.Font
  calendarEventPopupFullDateFont: StyleParamType.Font
  calendarEventPopupLocationFont: StyleParamType.Font
  calendarEventPopupDescriptionFont: StyleParamType.Font
  calendarEventPopupMembersFont: StyleParamType.Font
  calendarHollowRsvpButtonFont: StyleParamType.Font
  calendarFullRsvpButtonFont: StyleParamType.Font
  todayHollowButtonFont: StyleParamType.Font
  todayButtonFont: StyleParamType.Font
  ribbonFont: StyleParamType.Font
  soldOutRibbonFont: StyleParamType.Font
  rsvpClosedRibbonFont: StyleParamType.Font
  joinWaitlistRibbonFont: StyleParamType.Font
  membershipRibbonFont: StyleParamType.Font
  recurringRibbonFont: StyleParamType.Font
  hollowButtonsFont: StyleParamType.Font
  fullButtonsFont: StyleParamType.Font
  countdownFont: StyleParamType.Font
  titleFont: StyleParamType.Font
  descriptionFont: StyleParamType.Font
  labelsFont: StyleParamType.Font
  compactTextsFont: StyleParamType.Font
  textsFont: StyleParamType.Font
  firstPriorityEventBadgeFont: StyleParamType.Font
  secondPriorityEventBadgeFont: StyleParamType.Font
  thirdPriorityEventBadgeFont: StyleParamType.Font
  categoryMenuFont: StyleParamType.Font
  calendarHeaderTitleFont: StyleParamType.Font
  calendarHeaderCategoryButtonFont: StyleParamType.Font
  calendarHeaderDatePickerButtonFont: StyleParamType.Font

  eventTitleFontV2: StyleParamType.Font
  eventDateFontV2: StyleParamType.Font
  eventLocationFontV2: StyleParamType.Font
  eventDescriptionFontV2: StyleParamType.Font
  linkFontV2: StyleParamType.Font
  listTitleFontV2: StyleParamType.Font
  listFullButtonFontV2: StyleParamType.Font
  listHollowButtonFontV2: StyleParamType.Font
  listCountdownFont: StyleParamType.Font

  hoveredEventTitleFontV2: StyleParamType.Font
  hoveredEventDateFontV2: StyleParamType.Font
  hoveredEventLocationFontV2: StyleParamType.Font
  hoveredEventDescriptionFontV2: StyleParamType.Font
} & DeprecatedFonts

type IStylesColors = {
  calendarCellBackground: StyleParamType.Color
  calendarBorderColor: StyleParamType.Color
  calendarMainActiveColor: StyleParamType.Color
  listGeneralTitleColor: StyleParamType.Color
  calendarMonthColor: StyleParamType.Color
  calendarWeekdaysColor: StyleParamType.Color
  calendarDayNumberColor: StyleParamType.Color
  calendarCellEventNameColor: StyleParamType.Color
  calendarCellEventTimeColor: StyleParamType.Color
  calendarCellMoreEventsColor: StyleParamType.Color
  calendarCellTodayColor: StyleParamType.Color // TODO: find better name when ux & content is decided
  listHollowButtonFontColor: StyleParamType.Color
  listFullButtonFontColor: StyleParamType.Color
  todayHollowButtonColor: StyleParamType.Color
  todayButtonColor: StyleParamType.Color
  ribbonTextColor: StyleParamType.Color
  soldOutRibbonTextColor: StyleParamType.Color
  rsvpClosedRibbonTextColor: StyleParamType.Color
  joinWaitlistRibbonTextColor: StyleParamType.Color
  membershipRibbonTextColor: StyleParamType.Color
  recurringRibbonTextColor: StyleParamType.Color
  onImageHollowButtonsFontColor: StyleParamType.Color
  hollowButtonsFontColor: StyleParamType.Color
  onImageFullButtonsFontColor: StyleParamType.Color
  fullButtonsFontColor: StyleParamType.Color
  countdownColor: StyleParamType.Color
  onImageCountdownColor: StyleParamType.Color
  titleColor: StyleParamType.Color
  onImageTitleColor: StyleParamType.Color
  onImageDescriptionColor: StyleParamType.Color
  descriptionColor: StyleParamType.Color
  onImageLabelsColor: StyleParamType.Color
  labelsColor: StyleParamType.Color
  onImageTextsColor: StyleParamType.Color
  textsColor: StyleParamType.Color
  calendarCellBorderColor: StyleParamType.Color
  calendarPastDaysBackground: StyleParamType.Color
  listButtonBackgroundColor: StyleParamType.Color
  listButtonBorderColor: StyleParamType.Color
  listButtonHoverColor: StyleParamType.Color
  todayButtonBackgroundColor: StyleParamType.Color
  todayButtonBorderColor: StyleParamType.Color
  widgetBackgroundColor: StyleParamType.Color
  widgetBorderColor: StyleParamType.Color
  listItemBorderAndDividerColor: StyleParamType.Color
  listItemBackgroundColor: StyleParamType.Color
  /**
   * @deprecated
   */
  listImageBackgroundColor: StyleParamType.Color
  multiImageBackgroundColor: StyleParamType.Color
  multiImageBorderColor: StyleParamType.Color
  ribbonBackgroundColor: StyleParamType.Color
  soldOutRibbonBackgroundColor: StyleParamType.Color
  rsvpClosedRibbonBackgroundColor: StyleParamType.Color
  joinWaitlistRibbonBackgroundColor: StyleParamType.Color
  membershipRibbonBorderColor: StyleParamType.Color
  recurringRibbonBorderColor: StyleParamType.Color
  imageBackgroundColor: StyleParamType.Color
  backgroundColor: StyleParamType.Color
  borderColor: StyleParamType.Color
  onImageButtonsBorderColor: StyleParamType.Color
  buttonsBorderColor: StyleParamType.Color
  onImageButtonsBackgroundColor: StyleParamType.Color
  buttonsBackgroundColor: StyleParamType.Color
  onImageDividerColor: StyleParamType.Color
  dividerColor: StyleParamType.Color
  calendarBackgroundColor: StyleParamType.Color
  listHeaderDateColor: StyleParamType.Color
  listLoadMoreContainerBackgroundColor: StyleParamType.Color
  listCountdownColor: StyleParamType.Color
  listCountdownBorderColor: StyleParamType.Color
  listCountdownBackgroundColor: StyleParamType.Color
  firstPriorityEventBadgeColor: StyleParamType.Color
  secondPriorityEventBadgeColor: StyleParamType.Color
  thirdPriorityEventBadgeColor: StyleParamType.Color
  firstPriorityEventBadgeBackgroundColor: StyleParamType.Color
  secondPriorityEventBadgeBackgroundColor: StyleParamType.Color
  thirdPriorityEventBadgeBackgroundColor: StyleParamType.Color
  firstPriorityEventBadgeBorderColor: StyleParamType.Color
  secondPriorityEventBadgeBorderColor: StyleParamType.Color
  thirdPriorityEventBadgeBorderColor: StyleParamType.Color
  calendarGridBackgroundColor: StyleParamType.Color
  calendarGridBorderColor: StyleParamType.Color
  calendarGridBoxShadowColor: StyleParamType.Color
  calendarCellBoxShadowColor: StyleParamType.Color
  calendarHeaderTitleColor: StyleParamType.Color
  calendarHeaderCategoryButtonColor: StyleParamType.Color
  calendarHeaderDatePickerButtonColor: StyleParamType.Color
  calendarHeaderBorderColor: StyleParamType.Color
  calendarHeaderBackgroundColor: StyleParamType.Color
  calendarEventPopupEventNameColor: StyleParamType.Color
  calendarEventPopupFullDateColor: StyleParamType.Color
  calendarEventPopupLocationColor: StyleParamType.Color
  calendarEventPopupDescriptionColor: StyleParamType.Color
  calendarEventPopupMembersColor: StyleParamType.Color
  calendarEventPopupShareIconsColor: StyleParamType.Color
  calendarEventPopupBackgroundColor: StyleParamType.Color
  calendarEventPopupBorderColor: StyleParamType.Color
  calendarEventPopupBoxShadowColor: StyleParamType.Color
  calendarFullRsvpButtonBackgroundColor: StyleParamType.Color
  calendarHollowRsvpButtonFontColor: StyleParamType.Color
  calendarFullRsvpButtonFontColor: StyleParamType.Color
  calendarHollowRsvpButtonBorderColor: StyleParamType.Color
  calendarRsvpButtonHoverColor: StyleParamType.Color

  eventTitleColorV2: StyleParamType.Color
  eventDateColorV2: StyleParamType.Color
  eventLocationColorV2: StyleParamType.Color
  eventDescriptionColorV2: StyleParamType.Color
  linkColorV2: StyleParamType.Color

  hoveredEventTitleColorV2: StyleParamType.Color
  hoveredEventDateColorV2: StyleParamType.Color
  hoveredEventLocationColorV2: StyleParamType.Color
  hoveredEventDescriptionColor: StyleParamType.Color
  shareIconsColorV2: StyleParamType.Color
  eventBoxShadowColor: StyleParamType.Color
  calendarHeaderBoxShadowColor: StyleParamType.Color
  imageOverlayColor: StyleParamType.Color
  categoryMenuColor: StyleParamType.Color
  categoryMenuDividerColor: StyleParamType.Color
  categoryMenuSelectedUnderlineColor: StyleParamType.Color
} & DeprecatedColors

type ParamsMapper<Type, Val> = {
  [Property in keyof Type]: Val
}

export type WidgetStyleParams = {
  numbers: ParamsMapper<IStylesNumbers, number>
  booleans: ParamsMapper<IStylesBooleans, boolean> & {responsive: boolean; __IS_RTL__: boolean}
  colors: IStylesColors
  fonts: IStylesFonts
  strings: any
}

export type IStyles = IStylesNumbers & IStylesBooleans & IStylesColors & IStylesFonts

export type WidgetComponentSettings = Override<IStylesNumbers & ISettingsNumbers, number> &
  Override<IStylesBooleans, boolean> & {texts: WidgetComponentTextSettings} & {responsive: boolean}

const customColor = (value: string) => ({
  value,
  name: null,
  opacity: 1,
})

type IWidgetStyles = {
  listLayout: StyleParamType.Number
  listLayoutType: StyleParamType.Number
  mobileListLayout: StyleParamType.Number
  listShowImage: StyleParamType.Boolean
  mobileWidgetLayout: StyleParamType.Number
  mobileListLayoutType: StyleParamType.Number
  widgetType: StyleParamType.Number
  listTitleFontV2: StyleParamType.Font
  eventTitleColorV2: StyleParamType.Color
  eventDateColorV2: StyleParamType.Color
  eventLocationColorV2: StyleParamType.Color
  eventDescriptionColorV2: StyleParamType.Color
  linkColorV2: StyleParamType.Color
  shareIconsColorV2: StyleParamType.Color
  eventTitleFontV2: StyleParamType.Font
  eventDateFontV2: StyleParamType.Font
  eventLocationFontV2: StyleParamType.Font
  eventDescriptionFontV2: StyleParamType.Font
  linkFontV2: StyleParamType.Font
  listFullButtonFontV2: StyleParamType.Font
  listHollowButtonFontV2: StyleParamType.Font
  listTopMargin: StyleParamType.Number
  listBottomMargin: StyleParamType.Number
  listLeftMargin: StyleParamType.Number
  listRightMargin: StyleParamType.Number
  calendarCellEventNameFont: StyleParamType.Font
  calendarMainActiveColor: StyleParamType.Color
  listGeneralTitleColor: StyleParamType.Color
  listButtonStyle: StyleParamType.Number
  listButtonBorderColor: StyleParamType.Color
  listButtonBackgroundColor: StyleParamType.Color
  calendarDetailsTitleTextSize: StyleParamType.Number
  calendarCellEventNameColor: StyleParamType.Color
  calendarDetailsDateLocationTextSize: StyleParamType.Number
  calendarDetailsDescriptionTextSize: StyleParamType.Number
  listHollowButtonFontColor: StyleParamType.Color
  listFullButtonFontColor: StyleParamType.Color
  listButtonBorderWidth: StyleParamType.Number
  listRoundedButtonBorderRadius: StyleParamType.Number
  listButtonBorderRadius: StyleParamType.Number
  listButtonHoverColor: StyleParamType.Color
  calendarCellBackground: StyleParamType.Color
  calendarCellBorderWidth: StyleParamType.Number
}

const deprecatedStyles = createDeprecatedStyles()
const paramsMap = getV2ParamsMap(deprecatedStyles)

const getDefaultListMargin: IStyleParam['getDefaultValue'] = ({isMobile, getStyleParamValue}) => {
  const layout = getStyleParamValue(widgetStyles.listLayout)

  return isMobile
    ? 20
    : [LIST_LAYOUT.NEW_GRID, LIST_LAYOUT.GRID].includes(layout)
    ? getStyleParamValue(deprecatedStyles.cardMargins)
    : [LIST_LAYOUT.SIDE_BY_SIDE, LIST_LAYOUT.CALENDAR, LIST_LAYOUT.ON_IMAGE].includes(layout)
    ? 20
    : 30
}

export const widgetStyles = createStylesParams<IWidgetStyles>({
  listLayout: {
    type: StyleParamType.Number,
    getDefaultValue: () => LIST_LAYOUT.NEW_GRID,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_LAYOUT.NEW_GRID,
      },
    },
  },
  listLayoutType: {
    type: StyleParamType.Number,
    getDefaultValue: () => LIST_LAYOUT_TYPE.STRIPS,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_LAYOUT_TYPE.STRIPS,
      },
    },
  },
  mobileListLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => {
      if (getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.ON_IMAGE) {
        return MOBILE_LIST_LAYOUT.ON_IMAGE
      }

      return MOBILE_LIST_LAYOUT.FULL
    },
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: MOBILE_LIST_LAYOUT.FULL,
      },
    },
  },
  listShowImage: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  mobileWidgetLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => {
      const mobileListLayout = getStyleParamValue(widgetStyles.mobileListLayout)

      return mobileListLayout === MOBILE_LIST_LAYOUT.COMPACT ||
        getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? MOBILE_WIDGET_LAYOUT.LIST
        : mobileListLayout === MOBILE_LIST_LAYOUT.ON_IMAGE
        ? MOBILE_WIDGET_LAYOUT.ON_IMAGE
        : MOBILE_WIDGET_LAYOUT.GRID
    },
  },
  mobileListLayoutType: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.mobileListLayout) === MOBILE_LIST_LAYOUT.COMPACT
        ? MOBILE_LIST_LAYOUT_TYPE.STRIPS
        : getStyleParamValue(widgetStyles.listLayoutType) === LIST_LAYOUT_TYPE.CARDS
        ? MOBILE_LIST_LAYOUT_TYPE.CARDS
        : MOBILE_LIST_LAYOUT_TYPE.FULL,
  },
  widgetType: {
    type: StyleParamType.Number,
    getDefaultValue: () => WIDGET_TYPE.LIST,
  },
  listTopMargin: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListMargin,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 20,
      },
    },
  },
  listBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListMargin,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 20,
      },
    },
  },
  listLeftMargin: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListMargin,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 20,
      },
    },
  },
  listRightMargin: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListMargin,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 20,
      },
    },
  },
  listTitleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.LIST_TITLE, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Page-title',
        size: 36,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Page-title',
        size: 28,
      },
    },
  },
  eventTitleColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.TITLE, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 1,
      },
    },
  },
  eventDateColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.DATE, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 1,
      },
    },
  },
  eventLocationColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.LOCATION, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 1,
      },
    },
  },
  eventDescriptionColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.DESCRIPTION, map: paramsMap}),
  },
  linkColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getWidgetFontColorDefault({params, widgetText: WidgetText.LINK, map: paramsMap}),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  shareIconsColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => getSocialShareDefault(params, deprecatedStyles),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  eventTitleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.TITLE, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 26,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 20,
      },
    },
  },
  eventDateFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.DATE, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  eventLocationFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.LOCATION, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  eventDescriptionFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.DESCRIPTION, map: paramsMap}),
  },
  linkFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params => getWidgetFontDefault({params, widgetText: WidgetText.LINK, map: paramsMap}),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  listFullButtonFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetButtonDefaultFont({
        params,
        fontParam: deprecatedStyles.listFullButtonFont,
        mobileSizeParam: deprecatedStyles.listButtonFontSizeMobile,
        mobileCompactSizeParam: deprecatedStyles.listButtonFontSizeCompactMobile,
      }),
  },
  listHollowButtonFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetButtonDefaultFont({
        params,
        fontParam: deprecatedStyles.listHollowButtonFont,
        mobileSizeParam: deprecatedStyles.listButtonFontSizeMobile,
        mobileCompactSizeParam: deprecatedStyles.listButtonFontSizeCompactMobile,
      }),
  },
  calendarCellEventNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarMainActiveColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  listGeneralTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  listButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => BUTTONS_STYLE.FULL,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: BUTTONS_STYLE.FULL,
      },
    },
  },
  listButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
        opacity: 1,
      },
    },
  },
  listButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
        opacity: 1,
      },
    },
  },
  calendarDetailsTitleTextSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.fontSize,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarCellEventNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  calendarDetailsDateLocationTextSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 14,
    metadata: {
      type: StyleType.fontSize,
      defaultValue: {
        type: 'static',
        value: 14,
      },
    },
  },
  calendarDetailsDescriptionTextSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 14,
    metadata: {
      type: StyleType.fontSize,
      defaultValue: {
        type: 'static',
        value: 14,
      },
    },
  },
  listHollowButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
      },
    },
  },
  listFullButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
      },
    },
  },
  listButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  listRoundedButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },
  listButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  listButtonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => {
      const style = getStyleParamValue(widgetStyles.listButtonStyle)

      return [BUTTONS_STYLE.HOLLOW, BUTTONS_STYLE.HOLLOW_ROUNDED].includes(style)
        ? getStyleParamValue(widgetStyles.listButtonBorderColor)
        : getStyleParamValue(widgetStyles.listButtonBackgroundColor)
    },
  },
  calendarCellBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
      },
    },
  },
  calendarCellBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
}) as {[P in keyof IWidgetStyles]: IStyleParam<IWidgetStyles[P]>}

const getDefaultListItemVerticalPadding: IStyleParam['getDefaultValue'] = ({isMobile, getStyleParamValue}) => {
  const layout = getStyleParamValue(widgetStyles.listLayout)
  const mobileLayout = getStyleParamValue(widgetStyles.mobileWidgetLayout)
  const featuredWidget = getStyleParamValue(widgetStyles.widgetType) === WIDGET_TYPE.FEATURED
  const listPadding = getStyleParamValue(deprecatedStyles.listStripWidth) + 10

  const onImageFeatured =
    featuredWidget && (isMobile ? mobileLayout === MOBILE_WIDGET_LAYOUT.ON_IMAGE : layout === LIST_LAYOUT.ON_IMAGE)

  if (onImageFeatured) {
    return isMobile ? 120 : 150
  }

  if (isMobile) {
    return mobileLayout === MOBILE_WIDGET_LAYOUT.LIST ? listPadding : 20
  } else {
    return layout === LIST_LAYOUT.SIDE_BY_SIDE ? 60 : layout === LIST_LAYOUT.LIST ? listPadding : 32
  }
}

const getDefaultListItemHorizontalPadding: IStyleParam['getDefaultValue'] = ({isMobile, getStyleParamValue}) => {
  const layout = getStyleParamValue(widgetStyles.listLayout)

  if (isMobile) {
    return getStyleParamValue(widgetStyles.mobileWidgetLayout) === MOBILE_WIDGET_LAYOUT.LIST
      ? getStyleParamValue(widgetStyles.mobileListLayoutType) === MOBILE_LIST_LAYOUT_TYPE.CARDS
        ? 30
        : 0
      : 20
  } else {
    return layout === LIST_LAYOUT.SIDE_BY_SIDE
      ? 60
      : layout === LIST_LAYOUT.LIST
      ? getStyleParamValue(widgetStyles.listLayoutType) === LIST_LAYOUT_TYPE.STRIPS
        ? 0
        : 30
      : 32
  }
}

const getDefaultRibbonColor: IStyleParam['getDefaultValue'] = params => {
  const {isMobile, getStyleParamValue} = params
  const showImage = getStyleParamValue(widgetStyles.listShowImage)
  const onImage = isMobile
    ? getStyleParamValue(widgetStyles.mobileWidgetLayout) === MOBILE_WIDGET_LAYOUT.ON_IMAGE
    : getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.ON_IMAGE

  return onImage && showImage ? wixColorParam('color-1')(params) : wixColorParam('color-5')(params)
}

const styleParams: Record<keyof IStyles, IStyleParam> = {
  ...widgetStyles,
  ...deprecatedStyles,
  onImageCardHeightBehavior: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return ON_IMAGE_CARD_HEIGHT_BEHAVIOR.FIXED
    },
  },
  borderWidth: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 0
    },
  },
  todayButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 1
    },
  },
  todayButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 0
    },
  },
  calendarBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 0
    },
  },
  buttonsBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 1
    },
  },
  todayRoundedButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue() {
      return 100
    },
  },
  widgetLayout: {
    type: StyleParamType.Number,
    getDefaultValue: () => WIDGET_LAYOUT.FULL,
  },
  alignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
  },
  contentAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
  },
  listAlignment: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: ({isMobile, getStyleParamValue}) => {
      const mobileOnImage = getStyleParamValue(widgetStyles.mobileWidgetLayout) === MOBILE_WIDGET_LAYOUT.ON_IMAGE

      return isMobile && !mobileOnImage ? LIST_ALIGNMENT.LEFT : LIST_ALIGNMENT.CENTER
    },
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_ALIGNMENT.CENTER,
      },
    },
  },
  imagePosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  verticalImagePosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  imageGridPosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  imageScaling: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_SCALING.CROP,
  },
  multiImageScaling: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_SCALING.CROP,
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'static',
        value: IMAGE_SCALING.CROP,
      },
    },
  },
  // if not set defaults to imageRatio
  multiImageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: IMAGE_RATIO['1:1'],
      },
    },
  },
  listImageSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => LIST_IMAGE_SIZE.SMALL,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_IMAGE_SIZE.SMALL,
      },
    },
  },
  imageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_RATIO['1:1'],
  },
  listImageLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({isRTL}) => (isRTL ? LIST_IMAGE_LAYOUT.RIGHT : LIST_IMAGE_LAYOUT.LEFT),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_IMAGE_LAYOUT.LEFT,
      },
    },
  },
  locationAndDateFormat: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  cardsPerRow: {
    type: StyleParamType.Number,
    getDefaultValue: () => 3,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 3,
      },
    },
  },
  buttonsStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => BUTTONS_STYLE.FULL,
  },
  buttonsBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  roundedButtonsBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  buttonHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 44,
  },
  oneButtonWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 140,
  },
  verticalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  verticalDividerHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 94,
  },
  horizontalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
  },
  horizontalDividerHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  compactHorizontalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 36,
  },
  compactHorizontalDividerHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  countdownMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
  },
  titleMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 36,
  },
  descriptionMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 42,
  },
  dateMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 42,
  },
  locationMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 54,
  },
  dateAndLocationMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 54,
  },
  rsvpMarginBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
  },
  imageWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 50,
  },
  imageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 70,
  },
  listItemTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListItemVerticalPadding,
    metadata: {
      type: StyleType.paddingTop,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  listItemBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListItemVerticalPadding,
    metadata: {
      type: StyleType.paddingBottom,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  listItemLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListItemHorizontalPadding,
    metadata: {
      type: StyleType.paddingLeft,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  listItemRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: getDefaultListItemHorizontalPadding,
    metadata: {
      type: StyleType.paddingRight,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  gapBetweenCards: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => {
      const layout = getStyleParamValue(widgetStyles.listLayout)

      return layout === LIST_LAYOUT.NEW_GRID || layout === LIST_LAYOUT.GRID || layout === LIST_LAYOUT.ON_IMAGE
        ? getStyleParamValue(deprecatedStyles.cardMargins)
        : layout === LIST_LAYOUT.SIDE_BY_SIDE
        ? getStyleParamValue(deprecatedStyles.sideBySideLayoutMargins)
        : 30
    },
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  listImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  multiImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.opacity,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },
  multiImageTopMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageLeftMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageRightMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImagePosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_ALIGNMENT.CENTER,
  },
  multiImageBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  multiImageBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  listImageWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 50,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 50,
      },
    },
  },
  calendarWeekStartDay: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_WEEK_START,
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'static',
        value: DEFAULT_WEEK_START,
      },
    },
  },
  calendarListTextSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 14,
    metadata: {
      type: StyleType.fontSize,
      defaultValue: {
        type: 'static',
        value: 14,
      },
    },
  },
  calendarListDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  todayButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => BUTTONS_STYLE.HOLLOW,
  },
  recurringFilter: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
  },
  showImage: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showCountdown: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showOfferRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showRecurringRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showDescription: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showDate: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showLocation: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showShareOptions: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showFullDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showHorizontalDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showCompactDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showLabels: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showRSVPTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showMembers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  listShowMainTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  listShowDescription: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  listShowSocialShare: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  listShowAdditionalInfo: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showSoldOutRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  showRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showRsvpClosedRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  showJoinWaitlistRibbon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2'),
  },
  calendarMonthColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  calendarMonthFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 18,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 18,
      },
    },
  },
  calendarWeekdaysColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  calendarWeekdaysFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  calendarDayNumberColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  calendarDayNumberFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 24,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 24,
      },
    },
  },
  calendarCellEventTimeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-4'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-4',
      },
    },
  },
  calendarCellEventNameFontNew: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameFont',
      },
    },
  },
  calendarCellEventTimeFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameFont',
      },
    },
  },
  calendarCellMoreEventsFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)

      return {...font, size: 14}
    },
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameFont',
      },
    },
  },
  calendarCellMoreEventsColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarMainActiveColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarCellTodayColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarMainActiveColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarEventPopupEventNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarDetailsTitleTextSize)

      return {...font, size}
    },
  },
  calendarEventPopupEventNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupFullDateFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarDetailsDateLocationTextSize)

      return {...font, size}
    },
  },
  calendarEventPopupFullDateColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupLocationFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(widgetStyles.calendarDetailsDateLocationTextSize)

      return {...font, size}
    },
  },
  calendarEventPopupLocationColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)
      const size = getStyleParamValue(styleParams.calendarDetailsDescriptionTextSize)

      return {...font, size}
    },
  },
  calendarEventPopupDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupMembersFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => {
      const font = getStyleParamValue(widgetStyles.calendarCellEventNameFont)

      return {...font, size: 14}
    },
  },
  calendarEventPopupMembersColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupShareIconsColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellEventNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellEventNameColor',
      },
    },
  },
  calendarEventPopupBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellBackground),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellBackground',
      },
    },
  },
  calendarEventPopupBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarCellBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'calendarCellBorderWidth',
      },
    },
  },
  calendarEventPopupBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.calendarMainActiveColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'calendarMainActiveColor',
      },
    },
  },
  calendarEventPopupTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderTopRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomLeftRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderBottomRightRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarEventPopupBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarEventPopupBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarEventPopupBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarEventPopupBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0.12,
      },
    },
  },
  calendarRsvpButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonStyle),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonStyle',
      },
    },
  },
  calendarRsvpButtonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonHoverColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonHoverColor',
      },
    },
  },
  calendarHollowRsvpButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonBorderColor',
      },
    },
  },
  calendarHollowRsvpButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listHollowButtonFontColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'listHollowButtonFontColor',
      },
    },
  },
  calendarFullRsvpButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonBackgroundColor',
      },
    },
  },
  calendarFullRsvpButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listFullButtonFontColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'listFullButtonFontColor',
      },
    },
  },
  calendarHollowRsvpButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listHollowButtonFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'listHollowButtonFontV2',
      },
    },
  },
  calendarFullRsvpButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listFullButtonFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'listFullButtonFontV2',
      },
    },
  },
  calendarRsvpButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonBorderWidth',
      },
    },
  },
  calendarRoundedRsvpButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listRoundedButtonBorderRadius),
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'ref',
        ref: 'listRoundedButtonBorderRadius',
      },
    },
  },
  calendarRsvpButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listButtonBorderRadius),
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'ref',
        ref: 'listButtonBorderRadius',
      },
    },
  },
  todayHollowButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  todayHollowButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
  },
  todayButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  todayButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
  },
  ribbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#FFFFFF'),
  },
  ribbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
  },
  soldOutRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#FFFFFF'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#FFFFFF', // TODO: check if works
      },
    },
  },
  soldOutRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  rsvpClosedRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#FFFFFF'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#FFFFFF', // TODO: check if works
      },
    },
  },
  rsvpClosedRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  joinWaitlistRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#FFFFFF'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#FFFFFF', // TODO: check if works
      },
    },
  },
  joinWaitlistRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  membershipRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: getDefaultRibbonColor,
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  membershipRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  recurringRibbonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: getDefaultRibbonColor,
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  recurringRibbonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  onImageHollowButtonsFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  hollowButtonsFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  onImageFullButtonsFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  fullButtonsFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  hollowButtonsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
  },
  fullButtonsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
  },
  countdownFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 20,
    }),
  },
  countdownColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  onImageCountdownColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  titleFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Page-title', {
      size: 46,
    }),
  },
  titleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  onImageTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  descriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 15,
    }),
  },
  onImageDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  descriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  labelsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
  },
  onImageLabelsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  labelsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  compactTextsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 24,
    }),
  },
  textsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 15,
    }),
  },
  onImageTextsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  textsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  calendarCellBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 1),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-2',
        opacity: 1,
      },
    },
  },
  calendarPastDaysBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 0.1),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-2',
        opacity: 0.1,
      },
    },
  },
  widgetBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({isMobile, getStyleParamValue}) => {
      const mobileCompact =
        getStyleParamValue(widgetStyles.mobileWidgetLayout) === MOBILE_WIDGET_LAYOUT.LIST &&
        getStyleParamValue(widgetStyles.mobileListLayoutType) !== MOBILE_LIST_LAYOUT_TYPE.FULL

      return getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listBackgroundColor)
        : isMobile && mobileCompact
        ? getStyleParamValue(deprecatedStyles.cardBackgroundColor)
        : getStyleParamValue(deprecatedStyles.cardsBackgroundColor)
    },
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
        opacity: 0,
      },
    },
  },
  widgetBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({colors, getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listBorderColor)
        : wixColorParam('color-2', 1)({colors}),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-2',
        opacity: 1,
      },
    },
  },
  widgetBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listBorderWidth)
        : 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  listItemBorderAndDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listDividerColor)
        : getStyleParamValue(deprecatedStyles.cardBorderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-2',
        opacity: 1,
      },
    },
  },
  listItemBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({colors, getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST &&
      getStyleParamValue(widgetStyles.widgetType) !== WIDGET_TYPE.FEATURED
        ? wixColorParam('color-1', 0)({colors})
        : getStyleParamValue(deprecatedStyles.cardBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
        opacity: 1,
      },
    },
  },
  listItemBorderAndDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) =>
      getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.LIST
        ? getStyleParamValue(deprecatedStyles.listDividerWidth)
        : getStyleParamValue(deprecatedStyles.cardBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  todayButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  todayButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  listImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  multiImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
        opacity: 1,
      },
    },
  },
  multiImageBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.2),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0.2,
      },
    },
  },
  ribbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#F64D43'),
  },
  soldOutRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#F64D43'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#F64D43', // TODO: check if it works with custom color
      },
    },
  },
  rsvpClosedRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#F64D43'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#F64D43', // TODO: check if it works with custom color
      },
    },
  },
  joinWaitlistRibbonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => customColor('#F64D43'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: '#F64D43', // TODO: check if it works with custom color
      },
    },
  },
  membershipRibbonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: getDefaultRibbonColor,
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  recurringRibbonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: getDefaultRibbonColor,
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  imageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  borderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 1),
  },
  onImageButtonsBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  buttonsBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  onImageButtonsBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  buttonsBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  onImageDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  dividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  calendarBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
        opacity: 0,
      },
    },
  },
  listHeaderDateColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
  },
  listLoadMoreContainerBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  listShowCountdown: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  listCountdownFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 12,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 12,
      },
    },
  },
  listCountdownColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
      },
    },
  },
  listCountdownBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
      },
    },
  },
  listCountdownBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.4),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0.4,
      },
    },
  },
  listCountdownTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  listCountdownTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  listCountdownBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  listCountdownBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  itemFixedHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 500,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 500,
      },
    },
  },
  itemHeightType: {
    type: StyleParamType.Number,
    getDefaultValue: () => ITEM_HEIGHT_TYPE.DYNAMIC,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ITEM_HEIGHT_TYPE.DYNAMIC,
      },
    },
  },
  topLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  topRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  bottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  bottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  eventBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  eventBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
  },
  eventBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  eventBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
  },
  eventBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
  },
  imageOverlayColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.45),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0.45,
      },
    },
  },
  categoryMenuColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  categoryMenuDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
  },
  categoryMenuSelectedUnderlineColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  listImageHoverEffect: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_HOVER_EFFECT.ZOOM_IN,
    metadata: {
      type: StyleType.numberEnum,
      defaultValue: {
        type: 'static',
        value: IMAGE_HOVER_EFFECT.ZOOM_IN,
      },
    },
  },
  listTextVerticalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue, isMobile}) =>
      !isMobile && [LIST_LAYOUT.SIDE_BY_SIDE, LIST_LAYOUT.LIST].includes(getStyleParamValue(widgetStyles.listLayout))
        ? VERTICAL_ALIGNMENT.CENTER
        : VERTICAL_ALIGNMENT.TOP,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: VERTICAL_ALIGNMENT.CENTER,
      },
    },
  },
  listShowMembers: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue, isMobile}) => {
      const onImage = isMobile
        ? getStyleParamValue(widgetStyles.mobileWidgetLayout) === MOBILE_WIDGET_LAYOUT.ON_IMAGE
        : getStyleParamValue(widgetStyles.listLayout) === LIST_LAYOUT.ON_IMAGE

      return !onImage
    },
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  hoveredEventTitleColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params =>
      getWidgetFontColorDefault({
        params,
        widgetText: WidgetText.TITLE,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventTitleColorV2,
      }),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'eventTitleColorV2',
      },
    },
  },
  hoveredEventDateColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params =>
      getWidgetFontColorDefault({
        params,
        widgetText: WidgetText.DATE,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventDateColorV2,
      }),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'eventDateColorV2',
      },
    },
  },
  hoveredEventLocationColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params =>
      getWidgetFontColorDefault({
        params,
        widgetText: WidgetText.LOCATION,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventLocationColorV2,
      }),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'eventLocationColorV2',
      },
    },
  },
  hoveredEventDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: params =>
      getWidgetFontColorDefault({
        params,
        widgetText: WidgetText.DESCRIPTION,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventDescriptionColorV2,
      }),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'eventDescriptionColorV2',
      },
    },
  },
  hoveredEventTitleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetFontDefault({
        params,
        widgetText: WidgetText.TITLE,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventTitleFontV2,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'eventTitleFontV2',
      },
    },
  },
  hoveredEventDateFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetFontDefault({
        params,
        widgetText: WidgetText.DATE,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventDateFontV2,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'eventDateFontV2',
      },
    },
  },
  hoveredEventLocationFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetFontDefault({
        params,
        widgetText: WidgetText.LOCATION,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventLocationFontV2,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'eventLocationFontV2',
      },
    },
  },
  hoveredEventDescriptionFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getWidgetFontDefault({
        params,
        widgetText: WidgetText.DESCRIPTION,
        map: paramsMap,
        hover: true,
        defaultParam: widgetStyles.eventDescriptionFontV2,
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'eventDescriptionFontV2',
      },
    },
  },
  listExtraInfoShowDate: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(deprecatedStyles.listShowFullDate),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  listExtraInfoShowLocation: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(deprecatedStyles.listShowLocation),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  listShowDateV2: {
    type: StyleParamType.Boolean,
    getDefaultValue: params => getWidgetDateVisibilityDefault(params, deprecatedStyles),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  listShowLocationV2: {
    type: StyleParamType.Boolean,
    getDefaultValue: params => getWidgetLocationVisibilityDefault(params, deprecatedStyles),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  listLocationAndDateFormatV2: {
    type: StyleParamType.Number,
    getDefaultValue: params => getWidgetLocationDateFormatDefault(params, deprecatedStyles),
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: LIST_LOCATION_AND_DATE_FORMAT.COMPACT,
      },
    },
  },
  eventBadgeLayout: {
    type: StyleParamType.Number,
    getDefaultValue: ({isMobile, getStyleParamValue}) => {
      const layout = getStyleParamValue(widgetStyles.listLayout)
      const mobileLayout = getStyleParamValue(widgetStyles.mobileWidgetLayout)
      const mobileListLayoutType = getStyleParamValue(widgetStyles.mobileListLayoutType)
      const mobileCompactLayout =
        mobileLayout === MOBILE_WIDGET_LAYOUT.LIST && mobileListLayoutType !== MOBILE_LIST_LAYOUT_TYPE.FULL
      const eventInfo = isMobile
        ? mobileLayout === MOBILE_WIDGET_LAYOUT.ON_IMAGE || mobileCompactLayout
        : [LIST_LAYOUT.LIST, LIST_LAYOUT.ON_IMAGE].includes(layout)

      return eventInfo ? EVENT_BADGE_LAYOUT.EVENT_INFO : EVENT_BADGE_LAYOUT.ON_IMAGE
    },
  },
  eventBadgeVerticalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => VERTICAL_ALIGNMENT.TOP,
  },
  eventBadgeHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => ALIGNMENT.LEFT,
  },
  eventBadgeStretched: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showFirstPriorityEventBadge: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showSecondPriorityEventBadge: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  showThirdPriorityEventBadge: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  firstPriorityEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  secondPriorityEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  thirdPriorityEventBadgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  categoryMenuFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
  },
  firstPriorityEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
      },
    },
  },
  secondPriorityEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
      },
    },
  },
  thirdPriorityEventBadgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
      },
    },
  },
  firstPriorityEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
      },
    },
  },
  secondPriorityEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
      },
    },
  },
  thirdPriorityEventBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
      },
    },
  },
  firstPriorityEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
      },
    },
  },
  secondPriorityEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
      },
    },
  },
  thirdPriorityEventBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-8',
      },
    },
  },
  firstPriorityEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  firstPriorityEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  firstPriorityEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  firstPriorityEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  firstPriorityEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  secondPriorityEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  thirdPriorityEventBadgeBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarTopMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listTopMargin),
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'ref',
        ref: 'listTopMargin',
      },
    },
  },
  calendarBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listBottomMargin),
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'ref',
        ref: 'listBottomMargin',
      },
    },
  },
  calendarLeftMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listLeftMargin),
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'ref',
        ref: 'listLeftMargin',
      },
    },
  },
  calendarRightMargin: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listRightMargin),
    metadata: {
      type: StyleType.margin,
      defaultValue: {
        type: 'ref',
        ref: 'listRightMargin',
      },
    },
  },
  calendarHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 840,
    metadata: {
      type: StyleType.height,
      defaultValue: {
        type: 'static',
        value: 840,
      },
    },
  },
  calendarGridTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridHorizontalGap: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridVerticalGap: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
        opacity: 0,
      },
    },
  },
  calendarGridBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0,
      },
    },
  },
  calendarGridBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarGridBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarGridBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarGridBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarGridBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0.12,
      },
    },
  },
  calendarCellTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarCellBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarCellBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarCellBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarCellBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0.12,
      },
    },
  },
  calendarHeaderTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listTitleFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'listTitleFontV2',
      },
    },
  },
  calendarHeaderCategoryButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  calendarHeaderCategoryButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0,
      },
    },
  },
  calendarHeaderTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(widgetStyles.listGeneralTitleColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'listGeneralTitleColor',
      },
    },
  },
  calendarHeaderBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0,
      },
    },
  },
  calendarHeaderBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-1',
        opacity: 0,
      },
    },
  },
  calendarHeaderBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderTopLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderTopRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBottomLeftBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBottomRightBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBoxShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  calendarHeaderBoxShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  calendarHeaderBoxShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  calendarHeaderBoxShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  calendarHeaderBoxShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0.12,
      },
    },
  },
  calendarHeaderDatePickerButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  calendarHeaderDatePickerButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'color-5',
        opacity: 0,
      },
    },
  },
  calendarCellTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 12,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 12,
      },
    },
  },
  calendarCellBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 8,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 8,
      },
    },
  },
  calendarCellLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 15,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 15,
      },
    },
  },
  calendarCellRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 15,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 15,
      },
    },
  },
  calendarCellHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => ALIGNMENT.LEFT,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ALIGNMENT.LEFT,
      },
    },
  },
  calendarPopupHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => ALIGNMENT.LEFT,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ALIGNMENT.LEFT,
      },
    },
  },
  eventsPerCalendarCell: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  calendarWeekdaysHorizontalAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => ALIGNMENT.LEFT,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ALIGNMENT.LEFT,
      },
    },
  },
  calendarWeekdaysBottomMargin: {
    type: StyleParamType.Number,
    getDefaultValue: () => 10,
    metadata: {
      type: StyleType.marginBottom,
      defaultValue: {
        type: 'static',
        value: 10,
      },
    },
  },
  calendarLayoutType: {
    type: StyleParamType.Number,
    getDefaultValue: () => CALENDAR_LAYOUT.MONTHLY,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: CALENDAR_LAYOUT.MONTHLY,
      },
    },
  },
  calendarPopupTopPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.paddingTop,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarPopupBottomPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.paddingBottom,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarPopupLeftPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.paddingLeft,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
  calendarPopupRightPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.paddingRight,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
}

export const getDefaultNumbersAndBooleans = ({isMobile, isRTL, getStyleParamValue = () => null}) =>
  Object.entries(styleParams).reduce((acc, [key, value]) => {
    if (value.type === StyleParamType.Boolean || value.type === StyleParamType.Number) {
      acc[key] = value.getDefaultValue({isMobile, isRTL, getStyleParamValue} as any)
      return acc
    }
    return acc
  }, {})

export default createStylesParams<IStyles>(styleParams)

export {customCssVars} from './custom-css-vars'
